import InterfaceErrorHandler from './InterfaceErrorHandler';

export default InterfaceErrorHandler;
